import * as yup from 'yup';
import { WoundDescriptionSchema } from './woundDescription.schema';

export const WoundReportSchema = yup
  .object({
    description: yup.string().required(),
  })
  .concat(WoundDescriptionSchema);
export type IWoundReport = yup.InferType<typeof WoundReportSchema>;

export const WoundReportCreateSchema = yup
  .object({
    woundId: yup.string().required(),
    residentId: yup.string().required(),
  })
  .concat(WoundReportSchema);
export type IWoundReportCreate = yup.InferType<typeof WoundReportCreateSchema>;

export const WoundReportUpdateSchema = yup
  .object({
    id: yup.string().required(),
    woundId: yup.string().required(),
    residentId: yup.string().required(),
  })
  .concat(WoundReportSchema);
export type IWoundReportUpdate = yup.InferType<typeof WoundReportUpdateSchema>;
